import { MapPin, Clock, Mail, Phone } from "lucide-react";
import { CONTACTO, IMG } from "@/data/content";
import { Reveal, SectionTag, TituloLineas } from "@/components/Reveal";
import LeadForm from "@/components/LeadForm";

export default function Contacto() {
  return (
    <section id="contacto" className="scroll-mt-20 bg-abyss px-4 py-14 sm:px-8 sm:py-20 lg:px-12 lg:py-32">
      <div className="mx-auto grid max-w-[1400px] gap-14 lg:grid-cols-2 lg:gap-20">
        <div>
          <Reveal>
            <SectionTag>Contacto</SectionTag>
            <TituloLineas
              lineas={["Hablemos de su", "próxima operación"]}
              className="mt-5 font-display text-2xl font-bold uppercase leading-tight tracking-tight text-mist sm:text-3xl lg:text-4xl"
            />
            <p className="mt-5 max-w-md text-sm leading-relaxed text-smoke sm:text-base">
              Complete el formulario y el equipo CERTERO lo contactará. También puede escribirnos
              directo por WhatsApp para una respuesta inmediata.
            </p>
          </Reveal>
          <Reveal delay={0.1} className="mt-10">
            <LeadForm tipo="contacto" buttonLabel="Enviar mensaje" testidPrefix="contact" />
          </Reveal>
        </div>

        <div className="flex flex-col gap-5">
          <Reveal delay={0.15}>
            <div data-testid="contact-address-box" className="overflow-hidden border border-hud bg-ink">
              <img
                src={IMG.sedeFachada}
                alt="Fachada de la sede de CERTERO SRL en Av. Clara Cuta, Santa Cruz de la Sierra"
                loading="lazy"
                decoding="async"
                className="h-44 w-full object-cover"
                data-testid="contact-foto-fachada"
              />
              <div className="flex items-start gap-4 p-7 sm:p-8">
                <MapPin className="mt-1 h-5 w-5 shrink-0 text-certero" strokeWidth={1.5} />
                <div>
                  <h3 className="font-display text-base font-bold uppercase tracking-wide text-mist">Dirección</h3>
                  <p className="mt-1 text-sm leading-relaxed text-smoke">{CONTACTO.direccion}</p>
                  <p className="text-sm text-smoke">{CONTACTO.ciudad}</p>
                  <p className="mt-2 text-sm font-medium text-mist/85" data-testid="contact-así-nos-encuentra">
                    Así nos encuentra: Av. Clara Cuta n.º 68
                  </p>
                  <a
                    data-testid="contact-maps-link"
                    href={CONTACTO.maps}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-3 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-certero transition-colors duration-300 hover:text-[#4bc443]"
                  >
                    <MapPin className="h-3 w-3" /> Cómo llegar — Google Maps
                  </a>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <div className="grid gap-5 sm:grid-cols-2">
              <div className="border border-hud bg-ink p-7" data-testid="contact-horario">
                <Clock className="h-5 w-5 text-certero" strokeWidth={1.5} />
                <h3 className="mt-4 font-display text-base font-bold uppercase tracking-wide text-mist">Horario</h3>
                <p className="mt-1 text-sm text-smoke">Mañana: {CONTACTO.horarioManana}</p>
                <p className="text-sm text-smoke">Tarde: {CONTACTO.horarioTarde}</p>
              </div>
              <div className="border border-hud bg-ink p-7" data-testid="contact-directo">
                <Phone className="h-5 w-5 text-certero" strokeWidth={1.5} />
                <h3 className="mt-4 font-display text-base font-bold uppercase tracking-wide text-mist">Directo</h3>
                <a
                  data-testid="contact-whatsapp-direct"
                  href={CONTACTO.whatsappBusiness}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-1 block text-sm text-mist transition-colors duration-300 hover:text-certero"
                >
                  WhatsApp Business {CONTACTO.whatsappDisplay}
                </a>
                <p className="mt-1 text-xs text-smoke">Servicio al cliente, posventa, mantenimiento, servicio técnico y emergencias.</p>
                <a
                  href={`mailto:${CONTACTO.email}`}
                  className="mt-1 flex items-center gap-2 break-all text-sm text-mist transition-colors duration-300 hover:text-certero"
                >
                  <Mail className="h-3.5 w-3.5 shrink-0 text-smoke" /> {CONTACTO.email}
                </a>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.25}>
            <div className="border border-hud bg-ink p-7 sm:p-8">
              <h3 className="font-display text-base font-bold uppercase tracking-wide text-mist">Síganos</h3>
              <div className="mt-4 flex flex-wrap gap-3">
                {CONTACTO.redes.map((r) => (
                  <a
                    key={r.nombre}
                    data-testid={`contact-red-${r.nombre.toLowerCase()}`}
                    href={r.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="border border-hud px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.2em] text-mist/80 transition-[border-color,color] duration-300 hover:border-certero hover:text-certero"
                  >
                    {r.nombre}
                  </a>
                ))}
              </div>
              <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-smoke/60">
                @dji.certero.srl — Facebook · Instagram · TikTok
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
